import { QueryableTypes } from 'interfaces/queryableTypes';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

export const fetchQueryableTypes = () => {
  return apiRequestHandlerPromise<QueryableTypes>({
    url: `queryable_types`,
    method: 'GET',
  });
};
